<template>
    <div>
        <template v-for="(n, i) in typesCount">
            <b-row :key="'row_' + i" class="mb-2">
                <b-col cols="6">
                    <b-form-select
                            :key="'select_' + i"
                            v-model="typesContrat[i].type"
                            :state="getFieldState(typesContrat[i].type != null)"
                            :disabled="disabled"
                            @change="emit">
                        <template v-slot:first>
                            <b-form-select-option :value="null">
                                Sélectionner un type de contrat
                            </b-form-select-option>
                        </template>
                        <b-form-select-option v-for="(typeContratEnum,index) in typesContratEnum" :key="index"
                                              :value="typeContratEnum.value"
                                              :disabled="isDisabled(typeContratEnum.value)">
                            {{typeContratEnum.text}}
                        </b-form-select-option>
                    </b-form-select>
                </b-col>
                <b-col cols="4">
                    <b-form-input
                            v-b-tooltip.hover :title="'Ajouter un nombre d\'effectifs en équivalent temps plein pour chaque type de contrat'"
                            v-model="typesContrat[i].nbEffectif"
                            type="number"
                            step="any"
                            min="0"
                            @input="emit"
                            :disabled="disabled"
                            placeholder="Nombre d'effectifs"
                            :state="getFieldState(isFilledInput(typesContrat[i].nbEffectif))">
                    </b-form-input>
                </b-col>
                <b-col cols="1" v-if="n === typesCount && typesContrat[i].type != null && typesContrat[i].nbEffectif != null"
                       v-b-tooltip.hover.right
                       :title="'Ajouter un nouveau type de contrat'">
                    <Icon icon="plus" size="2x" :key="'add_' + i" @click="addType"
                          class="pt-2 typo-grey cursor-pointer"></Icon>
                </b-col>
                <b-col cols="1" v-if="typesCount === n && n > 1">
                    <Icon icon="minus" size="2x" :key="'remove_' + i"
                          @click="removeType(i)" class="pt-2 typo-grey cursor-pointer"></Icon>
                </b-col>
            </b-row>
        </template>
    </div>

</template>

<script>

  import TypeContratDto from "../../dtos/TypeContratDto";

  export default {
    name: "TypeContratGpec",
    props: ['value', 'typesContratEnum', 'disabled', 'formSubmitted', 'posteTouched'],
    data() {
      return {
        typesCount: 1,
        typesContrat: [new TypeContratDto()]
      }
    },
    watch: {
      value: function (vals) {
        this.initTypesContrat(vals);
      }
    },
    mounted() {
      this.initTypesContrat(this.value);
    },
    methods: {
      initTypesContrat(vals) {
        if (vals && vals.length > 0) {
          this.typesContrat = vals;
          this.typesCount = vals.length;
        } else {
          this.typesContrat = [new TypeContratDto()];
          this.typesCount = 1;
        }
      },
      getFieldState(fieldState) {
        return this.formSubmitted && this.posteTouched ? fieldState : null;
      },
      isFilledInput(value) {
        return value != null && value !== "";
      },
      emit() {
        this.$emit('input', this.typesContrat);
      },
      addType() {
        this.typesContrat.push(new TypeContratDto());
        this.typesCount++;
      },
      removeType(index) {
        this.typesCount--;
        this.typesContrat.splice(index, 1);
        this.emit();
      },
      isDisabled(typeContrat) {
        const isAlreadySelected = this.typesContrat.findIndex(aTypeContrat => aTypeContrat.type === typeContrat) !== -1;
        return this.disabled || isAlreadySelected;
      }
    }
  };
</script>
